/**
 * Topic Responses component created by karora on 26/05/17.
 */
import { map } from "rxjs/operators";
import { Component, OnInit } from "@angular/core";
import { AppComponent } from "../app.component";
import { ActivatedRoute, Params } from "@angular/router";
import { ProfileService } from "../services/profile.service";

@Component({
  selector: 'person-responses',
  template: `<person-detail></person-detail><responses></responses>`,
  styleUrls: [],
  providers: [],
  standalone: false
})


export class PersonResponsesComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) return;

    this.route.params.pipe(map((params: Params) => AppComponent.SetTitle("Person " + params['personid'])));
  }

}
